import { render, staticRenderFns } from "./user_guest.vue?vue&type=template&id=235bf607&scoped=true&"
import script from "./user_guest.vue?vue&type=script&lang=js&"
export * from "./user_guest.vue?vue&type=script&lang=js&"
import style0 from "./user_guest.vue?vue&type=style&index=0&id=235bf607&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235bf607",
  null
  
)

export default component.exports